import {EstimatesHttp} from "../../../http/estimates";

export default {
    /**
     *
     * @param commit
     * @param query <string, boolean>
     * @returns {Promise<void>}
     */
    async setEstimates({commit}) {
        const estimates = await EstimatesHttp.fetchEstimates().then(result => result.data);
        commit('setEstimates', estimates);
    },
    async setDrafts({commit}) {
        const estimates = await EstimatesHttp.fetchDrafts().then(result => result.data);
        commit('setDrafts', estimates);
    },
    async searchForEstimates({commit}, q) {
        const estimates = await EstimatesHttp.searchForEstimates(q).then(result => result.data);
        commit('setEstimates', estimates);
    },
    setActiveEstimate({commit}, estimate) {
        commit('setActiveEstimate', estimate);
    },
    setManageEstimateDialog({commit}, status) {
        commit('setManageEstimateDialog', status);
    },
    setDeleteEstimateDialog({commit}, status) {
        commit('setDeleteEstimateDialog', status);
    },
    resetActiveEstimate({commit}) {
        commit('resetActiveEstimate');
    },
}
